import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './locales/fr/common.json'
import auth from './locales/fr/auth.json'
import opportunities from './locales/fr/opportunities.json'
import properties from './locales/fr/properties.json'
import partners from './locales/fr/partners.json'
import links from './locales/fr/links.json'
import audit from './locales/fr/audit.json'
import conversions from './locales/fr/conversions.json'
import alerts from './locales/fr/alerts.json'

export const namespaces = [
  'common',
  'auth',
  'opportunities',
  'properties',
  'partners',
  'links',
  'audit',
  'conversions',
  'alerts',
] as const

void i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: namespaces,
  resources: {
    fr: {
      common,
      auth,
      opportunities,
      properties,
      partners,
      links,
      audit,
      conversions,
      alerts,
    },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
